//@ts-nocheck
import { get, post, put, del, request } from "requests";

// Fetch meetings for a specific date
export const fetchMeetings = async (date) => {
  return await get(`meetings?date=${date.toISOString()}`);
};

// Fetch all meetings
export const fetchAllMeetings = async () => {
  return await get(`meetings`);
};

// Fetch meetings by application ID
export const fetchMeetingsByApplicationId = async (applicationId) => {
  return await get(`meetings/application/${applicationId}`);
};

// Create a new meeting
export const createMeeting = async (meetingData) => {
  return await post(`meetings`, meetingData);
};

// Delete a meeting by ID
export const deleteMeeting = async (id) => {
  try {
    const response = await del(`meetings/${id}`);
    console.log("Meeting cancelled", id);
    return response;
  } catch (error) {
    console.error("Error cancelling meeting:", error);
    throw error;
  }
};

// Cancel a Zoom meeting by ID
export const cancelMeeting = async (zoomMeetingId, meetingData) => {
  return await request("patch", `meetings/cancel/${zoomMeetingId}`, meetingData);
};

// Download meeting recording
export const downloadRecording = async (id) => {
  console.log("Downloading recording with URL", `meetings/recording/${id}`);
  return await request(
    "get",
    `meetings/recording/${id}`,
    {},
    {
      responseType: "blob",
    }
  );
};

// Get the recording download URL (assumes response contains URL)
export const downloadRecording3 = async (id) => {
  const response = await get(`meetings/recording/${id}`);
  return response.data?.url || response.url; // fallback
};

// Download recording via `blob` manually
export const downloadRecording2 = async (meetingId) => {
  const blobResponse = await request(
    "get",
    `meetings/recording/${meetingId}`,
    {},
    {
      responseType: "blob",
      headers: { Accept: "application/octet-stream" },
    }
  );

  return blobResponse;
};

// Update an existing meeting
export const updateMeeting = async (zoomMeetingId, meetingData) => {
  return await request("patch", `meetings/${zoomMeetingId}`, meetingData);
};

// Check if a recording file is available
export const checkFileAvailability = async (meetingId) => {
  try {
    const response = await fetch(`/api/meetings/checkFileAvailability/${meetingId}`);
    return response.ok;
  } catch (error) {
    console.error("Error checking file availability:", error);
    return false;
  }
};
